export default "__VITE_ASSET__ad70f937__"